<ng-container *ngSubscribe="fields as fields">
  <field [field]="fields.sendTo" [hidden]="fields.sendTo.attributes.display_type === 'hidden'"></field>
  <field [field]="fields.cc"></field>
  <field [field]="fields.subject"></field>
  <field [field]="fields.intro"></field>
  <field [field]="fields.attachments"></field>
  <field [field]="fields.message"></field>
</ng-container>
